import { useSuspenseQuery } from "@apollo/client";

import { MapEditorEcologicalFunctionPanelEcologicalFunctionReadOnlyDocument } from "./queries.generated";

export function useSuspenseEcologicalFunctionReadOnlyQuery(mapEditorFeatureId: string) {
    return useSuspenseQuery(MapEditorEcologicalFunctionPanelEcologicalFunctionReadOnlyDocument, {
        variables: { mapEditorFeatureId },
    });
}
